import { useEffect } from 'react';
import {
  Dialog,
  ButtonSize,
  Typography,
  ButtonVariant,
  PrimaryButton,
  SecondaryButton,
} from '@uni-of-exeter/digital.lib.react.ui.kit';

import './evaluate-resources.css';
import { APP_TEXT } from '../../const/app-text';

// ------------------------------------------------------------

const text = APP_TEXT.components.evaluateResourceModal;

export interface EvaluateResourceModalProps {
  isOpen: boolean;
  onContinue: () => void;
  onClose: () => void;
}

const EvaluateResourceModal = ({ isOpen, onClose, onContinue }: EvaluateResourceModalProps) => {
  useEffect(() => {
    const rootElement = document.getElementById('root');
    if (!rootElement) return;
    rootElement.style.filter = isOpen ? 'blur(4px)' : '';
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      footer={<></>}
      className="evaluateResourceModal"
    >
      <div
        className="evaluateResourceModalWrapper"
        aria-modal
        role="alertdialog"
        aria-label="Evaluate Resource Modal"
      >
        <div className="externalResourceModalContent">
          <Typography
            variant="h2"
            className="evaluateResourceModalTitle"
          >
            {text.title}
          </Typography>

          <div className="evaluateResourceModalContent">
            <Typography
              className="evaluateResourceModalContentList"
              variant="body"
            >
              {text.body}
            </Typography>
          </div>
        </div>

        <div className="evaluateResourceModalFooter">
          <a
            className="feedbackText"
            href={text.feedbackLink}
            target="_blank"
            rel="noreferrer"
          >
            <Typography variant="body.small">{text.feedback}</Typography>
          </a>
          <div className="buttonsContainer">
            <SecondaryButton
              variant={ButtonVariant.Outline}
              size={ButtonSize.Large}
              onClick={onClose}
            >
              {text.close}
            </SecondaryButton>
            <PrimaryButton
              variant={ButtonVariant.Solid}
              size={ButtonSize.Large}
              onClick={onContinue}
              icon={<i className={`fa-regular fa-thumbs-up thumbIcon`} />}
            >
              {text.continue}
            </PrimaryButton>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default EvaluateResourceModal;
